// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4m-0";
export var eligibilityCardNotEligible = "_4m-1";